'use client';
import React, { useEffect, useRef, useState, useCallback } from 'react';

const dimensions = [
  {
    id: '01',
    label: 'Physical',
    headline: 'The body carries what the mind cannot process.',
    body: 'Chronic pain, fatigue, digestive dysfunction — these are the body\'s language for unresolved patterns. Naturopathy reads that language and responds at the root.',
    icon: (
      <svg data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:11:6" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="11" data-component-end-line="18" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <circle data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:12:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="12" data-component-end-line="12" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="20" cy="20" r="10" stroke="rgba(26,107,107,0.5)" strokeWidth="0.8" />
        <circle data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:13:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="13" data-component-end-line="13" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="20" cy="20" r="5" fill="rgba(26,107,107,0.12)" stroke="rgba(26,107,107,0.35)" strokeWidth="0.6" />
        <line data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:14:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="14" data-component-end-line="14" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="20" y1="4" x2="20" y2="10" stroke="rgba(26,107,107,0.4)" strokeWidth="0.7" />
        <line data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:15:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="15" data-component-end-line="15" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="20" y1="30" x2="20" y2="36" stroke="rgba(26,107,107,0.4)" strokeWidth="0.7" />
        <line data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:16:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="16" data-component-end-line="16" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="4" y1="20" x2="10" y2="20" stroke="rgba(26,107,107,0.4)" strokeWidth="0.7" />
        <line data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:17:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="17" data-component-end-line="17" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="30" y1="20" x2="36" y2="20" stroke="rgba(26,107,107,0.4)" strokeWidth="0.7" />
      </svg>
    ),
  },
  {
    id: '02',
    label: 'Emotional',
    headline: 'Unprocessed emotions become physical symptoms.',
    body: 'Grief lives in the chest. Fear in the gut. Anxiety, suppressed anger — each emotion that never found resolution becomes a pattern held in tissue and nervous system.',
    icon: (
      <svg data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:27:6" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="27" data-component-end-line="30" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <path data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:28:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="28" data-component-end-line="28" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M20 32 C10 24, 6 18, 6 14 C6 9.5 9.5 7 13 7 C16 7 18.5 9 20 11 C21.5 9 24 7 27 7 C30.5 7 34 9.5 34 14 C34 18 30 24 20 32Z" stroke="rgba(26,107,107,0.45)" strokeWidth="0.8" fill="rgba(26,107,107,0.07)" />
        <path data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:29:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="29" data-component-end-line="29" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M20 28 C13 22, 10 17, 10 14 C10 11.5 11.5 10 13 10 C15 10 17 11.5 20 14" stroke="rgba(26,107,107,0.2)" strokeWidth="0.5" fill="none" />
      </svg>
    ),
  },
  {
    id: '03',
    label: 'Energetic',
    headline: 'Depletion is not a lifestyle problem. It is a signal.',
    body: 'When the body\'s energetic field is disrupted, no supplement or willpower restores vitality. The energetic dimension governs how life force moves through you — and this is where lasting transformation is anchored.',
    icon: (
      <svg data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:39:6" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="39" data-component-end-line="46" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <circle data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:40:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="40" data-component-end-line="40" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="20" cy="20" r="14" stroke="rgba(26,107,107,0.15)" strokeWidth="0.5" />
        <circle data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:41:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="41" data-component-end-line="41" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="20" cy="20" r="9" stroke="rgba(26,107,107,0.25)" strokeWidth="0.6" />
        <circle data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:42:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="42" data-component-end-line="42" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="20" cy="20" r="4" stroke="rgba(26,107,107,0.45)" strokeWidth="0.7" fill="rgba(26,107,107,0.08)" />
        <circle data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:43:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="43" data-component-end-line="43" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="20" cy="20" r="1.5" fill="rgba(26,107,107,0.6)" />
        <path data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:44:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="44" data-component-end-line="44" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M20 6 Q26 13 20 20 Q14 27 20 34" stroke="rgba(26,107,107,0.3)" strokeWidth="0.6" fill="none" />
        <path data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:45:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="45" data-component-end-line="45" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M6 20 Q13 14 20 20 Q27 26 34 20" stroke="rgba(26,107,107,0.3)" strokeWidth="0.6" fill="none" />
      </svg>
    ),
  },
];

// Stage 0 = intro "Why healing stalls", Stages 1-3 = Physical/Emotional/Energetic
const TOTAL_STAGES = 4;
const STAGE_THRESHOLD = 280;

export default function PhysicalEmotionalEnergeticScene() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [stage, setStage] = useState(0);
  const [locked, setLocked] = useState(false);

  const accDelta = useRef(0);
  const lockedRef = useRef(false);
  const stageRef = useRef(0);

  useEffect(() => { lockedRef.current = locked; }, [locked]);
  useEffect(() => { stageRef.current = stage; }, [stage]);

  const enterLock = useCallback(() => {
    if (lockedRef.current) return;
    lockedRef.current = true;
    setLocked(true);
    sectionRef.current?.scrollIntoView({ behavior: 'instant' as ScrollBehavior });
  }, []);

  const exitLock = useCallback(() => {
    lockedRef.current = false;
    setLocked(false);
    accDelta.current = 0;
  }, []);

  // IntersectionObserver — always re-lock when section enters viewport
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          // Always re-lock on entry, reset accumulated delta
          accDelta.current = 0;
          enterLock();
        } else if (!entry.isIntersecting) {
          if (lockedRef.current) exitLock();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, [enterLock, exitLock]);

  // Wheel handler
  const handleWheel = useCallback(
    (e: WheelEvent) => {
      if (!lockedRef.current) return;
      e.preventDefault();
      e.stopPropagation();

      const delta = e.deltaY;
      const currentStage = stageRef.current;

      if (delta > 0) {
        accDelta.current += delta;
        if (accDelta.current >= STAGE_THRESHOLD) {
          accDelta.current = 0;
          if (currentStage < TOTAL_STAGES - 1) {
            setStage(currentStage + 1);
          } else {
            exitLock();
          }
        }
      } else if (delta < 0) {
        accDelta.current += delta;
        if (accDelta.current <= -STAGE_THRESHOLD) {
          accDelta.current = 0;
          if (currentStage > 0) {
            setStage(currentStage - 1);
          } else {
            exitLock();
          }
        }
      }
    },
    [exitLock]
  );

  const touchStartY = useRef(0);
  const handleTouchStart = useCallback((e: TouchEvent) => {
    touchStartY.current = e.touches[0].clientY;
  }, []);

  const handleTouchMove = useCallback(
    (e: TouchEvent) => {
      if (!lockedRef.current) return;
      e.preventDefault();
      const dy = touchStartY.current - e.touches[0].clientY;
      touchStartY.current = e.touches[0].clientY;
      const currentStage = stageRef.current;

      if (dy > 0) {
        accDelta.current += dy * 3;
        if (accDelta.current >= STAGE_THRESHOLD) {
          accDelta.current = 0;
          if (currentStage < TOTAL_STAGES - 1) {
            setStage(currentStage + 1);
          } else {
            exitLock();
          }
        }
      } else if (dy < 0) {
        accDelta.current += dy * 3;
        if (accDelta.current <= -STAGE_THRESHOLD) {
          accDelta.current = 0;
          if (currentStage > 0) {
            setStage(currentStage - 1);
          } else {
            exitLock();
          }
        }
      }
    },
    [exitLock]
  );

  // Attach wheel/touch to WINDOW when locked — captures all scroll events reliably
  useEffect(() => {
    if (!locked) return;

    window.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [locked, handleWheel, handleTouchStart, handleTouchMove]);

  // Lock both body and html scroll when locked
  useEffect(() => {
    if (locked) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [locked]);

  const dimIndex = stage - 1;
  const timelineFillPercent = dimIndex < 0 ? 0 : dimIndex === 0 ? 0 : dimIndex === 1 ? 50 : 100;
  const overallProgress = stage / (TOTAL_STAGES - 1);

  return (
    <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:211:4" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="211" data-component-end-line="515" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      ref={sectionRef}
      style={{
        position: 'relative',
        height: '100vh',
        background: '#F4EFE6',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Ambient gradient */}
      <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:223:6" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="223" data-component-end-line="229" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20pointer-events-none%22%7D"
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `radial-gradient(ellipse 70% 55% at 50% 50%, rgba(26,107,107,${0.04 + overallProgress * 0.06}) 0%, transparent 65%)`,
          transition: 'background 0.6s ease',
        }}
      />

      {/* Grain texture */}
      <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:232:6" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="232" data-component-end-line="238" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20pointer-events-none%20opacity-%5B0.018%5D%22%7D"
        className="absolute inset-0 pointer-events-none opacity-[0.018]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
          backgroundSize: '128px 128px',
        }}
      />

      {/* Top progress bar */}
      <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:241:6" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="241" data-component-end-line="253" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-0%20left-0%20right-0%20h-px%20pointer-events-none%22%7D"
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'rgba(26,107,107,0.1)' }}
      >
        <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:245:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="245" data-component-end-line="252" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          style={{
            height: '100%',
            width: `${overallProgress * 100}%`,
            background: 'rgba(26,107,107,0.45)',
            transition: 'width 0.08s linear',
          }}
        />
      </div>

      {/* Main layout */}
      <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:256:6" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="256" data-component-end-line="514" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%20flex%20flex-col%20flex-1%20items-center%20justify-center%20px-6%22%7D" className="relative z-10 flex flex-col flex-1 items-center justify-center px-6">

        {/* ── STAGE 0: Intro — Why Healing Stalls ── */}
        <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:259:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="259" data-component-end-line="323" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20flex%20flex-col%20items-center%20text-center%22%7D"
          className="absolute flex flex-col items-center text-center"
          style={{
            width: 'min(90vw, 640px)',
            opacity: stage === 0 ? 1 : 0,
            transform: stage === 0 ? 'translateY(0) scale(1)' : 'translateY(-16px) scale(0.98)',
            transition: 'opacity 0.6s cubic-bezier(0.4,0,0.2,1), transform 0.6s cubic-bezier(0.4,0,0.2,1)',
            pointerEvents: stage === 0 ? 'auto' : 'none',
          }}
        >
          <p data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:269:10" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="269" data-component-end-line="278" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20uppercase%20mb-8%20tracking-widest%22%2C%22textContent%22%3A%22Why%20healing%20stalls%22%7D"
            className="font-sans uppercase mb-8 tracking-widest"
            style={{
              fontSize: 'clamp(0.55rem, 0.8vw, 0.65rem)',
              color: 'rgba(26,107,107,0.65)',
              letterSpacing: '0.3em',
            }}
          >
            Why healing stalls
          </p>
          <h2 data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:279:10" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="279" data-component-end-line="289" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-serif%20text-balance%22%2C%22textContent%22%3A%22Most%20people%20are%20not%20unwell.%22%7D"
            className="font-serif text-balance"
            style={{
              fontSize: 'clamp(2.4rem, 5.5vw, 4.8rem)',
              color: 'rgba(36,44,44,0.88)',
              lineHeight: 1.0,
              maxWidth: '14ch',
            }}
          >
            Most people are not unwell.
          </h2>
          <h2 data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:290:10" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="290" data-component-end-line="300" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-serif%20text-balance%20mt-1%22%2C%22textContent%22%3A%22They%20are%20blocked.%22%7D"
            className="font-serif text-balance mt-1"
            style={{
              fontSize: 'clamp(2.4rem, 5.5vw, 4.8rem)',
              color: 'rgba(36,44,44,0.22)',
              lineHeight: 1.0,
              maxWidth: '14ch',
            }}
          >
            They are blocked.
          </h2>
          <p data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:301:10" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="301" data-component-end-line="310" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20font-light%20leading-relaxed%20mt-8%20mx-auto%22%2C%22textContent%22%3A%22Healing%20stalls%20when%20we%20treat%20symptoms%20without%20addressing%20the%20three%20dimensions%20that%20hold%20the%20block.%22%7D"
            className="font-sans font-light leading-relaxed mt-8 mx-auto"
            style={{
              fontSize: 'clamp(0.82rem, 1.1vw, 0.94rem)',
              color: 'rgba(36,44,44,0.42)',
              maxWidth: '44ch',
            }}
          >
            Healing stalls when we treat symptoms without addressing the three dimensions that hold the block.
          </p>
          <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:311:10" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="311" data-component-end-line="322" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20gap-2%20mt-12%22%7D" className="flex flex-col items-center gap-2 mt-12" style={{ opacity: 0.45 }}>
            <span data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:312:12" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="312" data-component-end-line="314" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-sans%20uppercase%20text-%5B0.55rem%5D%20tracking-%5B0.2em%5D%22%2C%22textContent%22%3A%22scroll%20to%20explore%22%7D" className="font-sans uppercase text-[0.55rem] tracking-[0.2em]" style={{ color: 'rgba(36,44,44,0.45)' }}>
              scroll to explore
            </span>
            <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:315:12" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="315" data-component-end-line="321" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              style={{
                width: '1px',
                height: '2rem',
                background: 'linear-gradient(to bottom, rgba(26,107,107,0.4), transparent)',
              }}
            />
          </div>
        </div>

        {/* ── STAGES 1-3: Dimension content ── */}
        <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:326:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="326" data-component-end-line="494" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          style={{
            opacity: stage >= 1 ? 1 : 0,
            transition: 'opacity 0.5s ease',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pointerEvents: stage >= 1 ? 'auto' : 'none',
          }}
        >
          <p data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:337:10" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="337" data-component-end-line="346" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20uppercase%20mb-10%20tracking-widest%22%2C%22textContent%22%3A%22The%20Three%20Dimensions%20of%20Healing%22%7D"
            className="font-sans uppercase mb-10 tracking-widest"
            style={{
              fontSize: 'clamp(0.55rem, 0.8vw, 0.65rem)',
              color: 'rgba(26,107,107,0.65)',
              letterSpacing: '0.3em',
            }}
          >
            The Three Dimensions of Healing
          </p>

          {/* Horizontal timeline */}
          <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:349:10" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="349" data-component-end-line="434" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20flex%20items-center%20justify-between%20mb-14%22%7D"
            className="relative flex items-center justify-between mb-14"
            style={{ width: 'min(88vw, 640px)', height: '52px' }}
          >
            <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:353:12" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="353" data-component-end-line="356" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-0%20right-0%22%7D"
              className="absolute left-0 right-0"
              style={{ top: '26px', height: '1px', background: 'rgba(26,107,107,0.15)' }}
            />
            <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:357:12" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="357" data-component-end-line="366" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-0%22%7D"
              className="absolute left-0"
              style={{
                top: '26px',
                height: '1px',
                width: `${timelineFillPercent}%`,
                background: 'rgba(26,107,107,0.5)',
                transition: 'width 0.55s cubic-bezier(0.4,0,0.2,1)',
              }}
            />

            {dimensions.map((dim, i) => {
              const isActive = i === dimIndex;
              const isPast = i < dimIndex;
              const nodeSize = isActive ? 52 : 36;
              return (
                <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:373:16" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="373" data-component-end-line="431" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20flex%20flex-col%20items-center%22%7D"
                  key={dim.id}
                  className="relative flex flex-col items-center"
                  style={{ zIndex: 1, height: '100%' }}
                >
                  <span data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:378:18" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="378" data-component-end-line="389" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-serif%20absolute%22%7D"
                    className="font-serif absolute"
                    style={{
                      top: `calc(26px - ${nodeSize / 2}px - 1.8rem)`,
                      fontSize: 'clamp(0.65rem, 0.9vw, 0.75rem)',
                      color: isActive ? 'rgba(26,107,107,0.65)' : isPast ? 'rgba(26,107,107,0.3)' : 'rgba(26,107,107,0.12)',
                      letterSpacing: '0.06em',
                      transition: 'color 0.55s ease, top 0.55s cubic-bezier(0.4,0,0.2,1)',
                    }}
                  >
                    {dim.id}
                  </span>
                  <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:390:18" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="390" data-component-end-line="417" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                    style={{
                      position: 'absolute',
                      top: '26px',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: `${nodeSize}px`,
                      height: `${nodeSize}px`,
                      borderRadius: '50%',
                      border: `1px solid ${isActive ? 'rgba(26,107,107,0.5)' : isPast ? 'rgba(26,107,107,0.25)' : 'rgba(26,107,107,0.12)'}`,
                      background: isActive ? 'rgba(26,107,107,0.08)' : isPast ? 'rgba(26,107,107,0.04)' : 'rgba(237,232,223,0.9)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.55s cubic-bezier(0.4,0,0.2,1)',
                      boxShadow: isActive ? '0 0 20px rgba(26,107,107,0.12)' : 'none',
                    }}
                  >
                    <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:408:20" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="408" data-component-end-line="416" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                      style={{
                        width: isActive ? '8px' : isPast ? '5px' : '4px',
                        height: isActive ? '8px' : isPast ? '5px' : '4px',
                        borderRadius: '50%',
                        background: isActive ? 'rgba(26,107,107,0.9)' : isPast ? 'rgba(26,107,107,0.45)' : 'rgba(26,107,107,0.2)',
                        transition: 'all 0.55s cubic-bezier(0.4,0,0.2,1)',
                      }}
                    />
                  </div>
                  <span data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:418:18" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="418" data-component-end-line="430" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-sans%20uppercase%20absolute%22%7D"
                    className="font-sans uppercase absolute"
                    style={{
                      top: `calc(26px + ${nodeSize / 2}px + 0.5rem)`,
                      fontSize: 'clamp(0.55rem, 0.75vw, 0.62rem)',
                      letterSpacing: '0.22em',
                      color: isActive ? 'rgba(26,107,107,0.85)' : isPast ? 'rgba(36,44,44,0.3)' : 'rgba(36,44,44,0.15)',
                      transition: 'color 0.55s ease, top 0.55s cubic-bezier(0.4,0,0.2,1)',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {dim.label}
                  </span>
                </div>
              );
            })}
          </div>

          {/* Content cards */}
          <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:437:10" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="437" data-component-end-line="493" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20flex%20justify-center%22%7D"
            className="relative w-full flex justify-center"
            style={{ minHeight: 'clamp(14rem, 22vw, 18rem)' }}
          >
            {dimensions.map((dim, i) => (
              <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:442:14" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="442" data-component-end-line="491" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20flex%20flex-col%20items-center%20text-center%22%7D"
                key={dim.id}
                className="absolute flex flex-col items-center text-center"
                style={{
                  width: 'min(90vw, 560px)',
                  opacity: dimIndex === i ? 1 : 0,
                  transform: dimIndex === i
                    ? 'translateY(0) scale(1)'
                    : dimIndex > i
                    ? 'translateY(-12px) scale(0.98)'
                    : 'translateY(16px) scale(0.98)',
                  transition: 'opacity 0.55s cubic-bezier(0.4,0,0.2,1), transform 0.55s cubic-bezier(0.4,0,0.2,1)',
                  pointerEvents: dimIndex === i ? 'auto' : 'none',
                }}
              >
                <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:457:16" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="457" data-component-end-line="459" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" style={{ width: 'clamp(40px, 5vw, 56px)', height: 'clamp(40px, 5vw, 56px)', marginBottom: '1.5rem', opacity: 0.85 }}>
                  {dim.icon}
                </div>
                <p data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:460:16" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="460" data-component-end-line="470" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-serif%20mb-4%22%7D"
                  className="font-serif mb-4"
                  style={{
                    fontSize: 'clamp(1.1rem, 2.2vw, 1.6rem)',
                    color: 'rgba(26,107,107,0.7)',
                    letterSpacing: '0.04em',
                    lineHeight: 1,
                  }}
                >
                  {dim.label}
                </p>
                <h2 data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:471:16" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="471" data-component-end-line="480" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-serif%20text-balance%20mb-6%22%7D"
                  className="font-serif text-balance mb-6"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
                    color: 'rgba(36,44,44,0.88)',
                    lineHeight: 1.1,
                  }}
                >
                  {dim.headline}
                </h2>
                <p data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:481:16" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="481" data-component-end-line="490" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20font-light%20leading-relaxed%20mx-auto%22%7D"
                  className="font-sans font-light leading-relaxed mx-auto"
                  style={{
                    fontSize: 'clamp(0.82rem, 1.1vw, 0.94rem)',
                    color: 'rgba(36,44,44,0.42)',
                    maxWidth: '44ch',
                  }}
                >
                  {dim.body}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Stage counter dots */}
        <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:497:8" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="497" data-component-end-line="513" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-8%20left-1%2F2%20flex%20gap-2%22%7D"
          className="absolute bottom-8 left-1/2 flex gap-2"
          style={{ transform: 'translateX(-50%)' }}
        >
          {Array.from({ length: TOTAL_STAGES }).map((_, i) => (
            <div data-component-id="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx:502:12" data-component-path="src/app/homepage/components/PhysicalEmotionalEnergeticScene.tsx" data-component-line="502" data-component-end-line="511" data-component-file="PhysicalEmotionalEnergeticScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={i}
              style={{
                width: i === stage ? '20px' : '5px',
                height: '5px',
                borderRadius: '3px',
                background: i === stage ? 'rgba(26,107,107,0.65)' : i < stage ? 'rgba(26,107,107,0.3)' : 'rgba(26,107,107,0.12)',
                transition: 'all 0.4s ease',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
